import { render, staticRenderFns } from "./DonorsData.vue?vue&type=template&id=30a1e60d&scoped=true"
import script from "./DonorsData.vue?vue&type=script&lang=js"
export * from "./DonorsData.vue?vue&type=script&lang=js"
import style0 from "./DonorsData.vue?vue&type=style&index=0&id=30a1e60d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a1e60d",
  null
  
)

export default component.exports